"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStore = exports.storeKey = void 0;
const process_1 = __importDefault(require("process"));
const wrappers_1 = require("quasar/wrappers");
const vuex_1 = require("vuex");
// import example from './module-example'
// import { ExampleStateInterface } from './module-example/state';
const ui_1 = __importDefault(require("./modules/ui"));
const auth_1 = __importDefault(require("./modules/auth"));
// provide typings for `useStore` helper
exports.storeKey = Symbol('vuex-key');
exports.default = wrappers_1.store(function ( /* { ssrContext } */) {
    const Store = vuex_1.createStore({
        modules: {
            // example
            ui: ui_1.default,
            auth: auth_1.default
        },
        // enable strict mode (adds overhead!)
        // for dev mode and --debug builds only
        strict: !!process_1.default.env.DEBUGGING,
    });
    return Store;
});
function useStore() {
    return vuex_1.useStore(exports.storeKey);
}
exports.useStore = useStore;
